<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading">
      {{ $t("loadingTxt") }}...
    </div>
    <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
      <!--begin::navbar-->
      <navbar-component></navbar-component>
      <!--end::navbar-->

      <div class="page-wrapper">
        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6
                    class="card-title mb-0 float-start"
                    style="padding-left: 25px">
                    {{ $t("billing_mapping_role_access_detail") }}
                  </h6>
                  <button
                    class="btn btn-light float-end"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseExample"
                    aria-expanded="false"
                    aria-controls="collapseExample">
                    <i class="link-icon" data-feather="info"></i>
                    Audit Info
                  </button>

                  <div
                    class="row mb-3 collapse"
                    id="collapseExample"
                    style="padding-left: 20px">
                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Created By:</label>
                      <p class="text-muted">{{ this.forms.addwho }}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Created At:</label>
                      <p class="text-muted">{{ this.forms.created_at }}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Updated By:</label>
                      <p class="text-muted">{{ this.forms.editwho }}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Updated At:</label>
                      <p class="text-muted">{{ this.forms.updated_at }}</p>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <form class="forms-sample" method="POST">
                    <!-- mapping_id -->
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="mapping_id"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >{{ $t("mapping_id") }}</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="mapping_id"
                          :placeholder="$t('mapping_id')"
                          v-model="forms.mapping_id"
                          readonly />
                        <div v-if="errors.mapping_id">
                          <div
                            v-for="error in errors.mapping_id"
                            :key="error"
                            class="alert alert-primary"
                            role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- role_name -->
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="role_name"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >{{ $t("role_name") }}</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="role_name"
                          :placeholder="$t('role_name')"
                          v-model="forms.role_name"
                          readonly />
                        <div v-if="errors.role_name">
                          <div
                            v-for="error in errors.role_name"
                            :key="error"
                            class="alert alert-primary"
                            role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- warehouse -->
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="warehouse"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >{{ $t("warehouse") }}</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <table class="table table-bordered">
                          <thead>
                            <tr>
                              <th>{{ $t("warehouse_id") }}</th>
                              <th>{{ $t("warehouse_name") }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(warehouse, index) in warehouses"
                              :key="index">
                              <td>{{ warehouse.warehouseId }}</td>
                              <td>{{ warehouse.warehouseName }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div class="card-footer">
                      <button
                        class="btn btn-warning text-black fw-bolder btn-icon-text"
                        @click="backForm"
                        type="button">
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>

                      <a
                        v-if="permision_role.method_delete"
                        class="btn btn-danger text-white fw-bolder btn-icon-text float-end"
                        @click="deleteData()">
                        <i class="link-icon" data-feather="trash"></i>
                        {{ $t("deleteMess") }}
                      </a>

                      <a
                        v-if="permision_role.method_update"
                        class="btn btn-primary me-2 text-white fw-bolder btn-icon-text float-end"
                        @click="editData()">
                        <i class="link-icon" data-feather="edit"></i>
                        {{ $t("editMess") }}
                      </a>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";

export default {
  name: "RoleAccessDetail",
  props: {},
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
  },
  data() {
    return {
      permision_role: [],
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      userData: "",
      companyCode: "",
      companyName: "",
      warehouses: [],
      forms: {
        mapping_id: "",
        role_id: "",
        role_name: "",
        datas: "",
        created_at: "",
        updated_at: "",
        addwho: "",
        editwho: "",
      },
    };
  },
  watch: {},
  methods: {
    editData() {
      var params = this.$route.params.mapping_id;
      window.location.href = "/billing-mapping/role-access/edit/" + params;
    },

    deleteData() {
      // Ambil nilai mapping_id dari parameter route
      var mapping_id = this.$onBehind(this.$route.params.mapping_id);

      // Tampilkan dialog konfirmasi sebelum menghapus data
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataDelete"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        // Jika pengguna mengonfirmasi penghapusan
        if (result.isConfirmed) {
          // Siapkan payload sesuai format endpoint
          const formData = {
            mapping_ids: [Number(mapping_id)], // Konversi ke angka jika diperlukan
          };

          // URL endpoint untuk penghapusan data
          const baseURI =
            this.$settings.endPointBilling +
            "mapping/role-user-billing/delete-mass";

          // Panggil API dengan metode DELETE
          this.$http
            .delete(baseURI, { data: formData, timeout: 10000 })
            .then((response) => {
              // Berhenti loading setelah respons diterima
              this.isLoading = false;

              if (response.data.status === 200) {
                // Tampilkan pesan sukses
                this.success(response.data.datas.messages);

                // Arahkan kembali ke halaman utama setelah penghapusan
                this.$router.push("/billing-mapping/role-access/");
              } else {
                // Tampilkan error jika status bukan 200
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              // Berhenti loading setelah respons gagal
              this.isLoading = false;

              if (error.code === "ECONNABORTED") {
                // Tampilkan pesan error jika koneksi timeout
                this.error(this.$t("check_internet_connection_txt"));
              } else if (error.response) {
                // Tangani error berdasarkan status respons
                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                  this.resultError(error.response.data.errors);
                } else if (error.response.status === 401) {
                  this.logout();
                } else if (error.response.status === 403) {
                  this.$router.push("/authorized-error");
                } else if (error.response.status === 500) {
                  this.$router.push("/server-error");
                } else {
                  this.$router.push("/page-not-found");
                }
              }
            });
        } else {
          // Jika pengguna membatalkan penghapusan, hentikan loading
          this.isLoading = false;
        }
      });
    },

    loadData(mapping_id) {
      this.isLoading = true;

      const baseURI =
        this.$settings.endPointBilling +
        "mapping/role-user-billing/detail/" +
        mapping_id;
      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.isLoading = false;
          this.forms = response.data.datas;

          // Parsing warehouse data from 'datas' field
          const warehouseData = JSON.parse(this.forms.datas).warehouse;
          this.warehouses = warehouseData; // Simpan data warehouse ke dalam array
        })
        .catch((error) => {
          this.isLoading = false;

          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    backForm() {
      window.location.href = "/billing-mapping/role-access/";
    },

    logout() {
      const baseURI = this.$settings.endPoint + "user/logout";
      this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
        console.log(response);
      });

      this.$logoutUser();
      window.location.href = "/";
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "MasterWarehouseCmlController") {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if (!rolePermision.method_read) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
        // onShown: function() {
        //     console.log('asdasdasd');
        //     //window.location.href = '/';
        // }
      });

      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    cek_message(status, msg) {
      if (status == "200") {
        this.success(msg);
      }
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.cek_message(this.$route.query.status, this.$route.query.msg);
    var params = this.$onBehind(this.$route.params.mapping_id);
    this.loadData(params[0]);
    this.fetchIt();
  },
};
</script>
<style scoped></style>
